import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shadow p-2 my-2 bg-white rounded" }
const _hoisted_2 = { class: "text font-bold" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "pl-2 text-sm" }

import { useRouter } from 'vue-router'
  import {computed } from 'vue'
  import { useReservationDaysStore } from '@/stores/ReservationDaysStore'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserEvent',
  props: {
    eventDescription:String,
    scheduledAt:String,
    hourCode:Number,
    eventPrice:Number,
    eventDuration:Number,
    eventid:Number,
    companyName:String,
    companyId:Number,
    companyAdress:String,
    companyCity:String,
    companyZipCode:String,
    employeeName:String,
  },
  setup(__props) {

const props = __props;

  const reservationStore = useReservationDaysStore();
  const timeDictionary =reservationStore.timeDictionary;

  const router = useRouter()

  

  // a computed ref
  const computedTime = computed(() => {
    var hourcomputed = props.hourCode ? props.hourCode  as number : -1;
    return timeDictionary[hourcomputed as keyof typeof timeDictionary];
  })

  const goToCompany = () => {
    router.push(`/company/${props.companyId}`);
  };


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.scheduledAt) + " : " + _toDisplayString(computedTime.value), 1),
    _createElementVNode("button", null, [
      _createElementVNode("p", {
        class: "text-sm font-bold underline",
        onClick: goToCompany
      }, _toDisplayString(__props.companyName), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.companyAdress) + ", ", 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(__props.companyCity) + ", ", 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(__props.companyZipCode), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.eventDescription) + " avec ", 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(__props.employeeName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, _toDisplayString(__props.eventDuration *15) + "min ", 1),
      _createElementVNode("p", _hoisted_12, _toDisplayString(__props.eventPrice) + " $", 1)
    ])
  ]))
}
}

})